import { render } from "./DBLabel.vue?vue&type=template&id=630755c7&lang=pug"
import script from "./DBLabel.vue?vue&type=script&lang=js"
export * from "./DBLabel.vue?vue&type=script&lang=js"

import "./DBLabel.vue?vue&type=style&index=0&id=630755c7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/SmartTable/DBLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "630755c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('630755c7', __exports__)) {
    api.reload('630755c7', __exports__)
  }
  
  module.hot.accept("./DBLabel.vue?vue&type=template&id=630755c7&lang=pug", () => {
    api.rerender('630755c7', render)
  })

}


export default __exports__